/**
 * Layout gutters (design canvas 1905px):
 * 100% zoom → 140px | 125% zoom → 45px | 150% zoom → 40px
 */
(function () {
  'use strict';

  var DESIGN_WIDTH = 1905;
  var DESIGN_OFFSET = 140;
  var OFFSET_AT_125 = 45;
  var MOBILE_MAX = 999;
  var MOBILE_OFFSET = 16;
  var MIN_OFFSET_DESKTOP = 40;
  var ZOOM_MID = 1.25;
  var ZOOM_TARGET = 1.5;
  var CONTENT_DESIGN = 1625;

  function getViewportWidth() {
    return document.documentElement.clientWidth || window.innerWidth || 0;
  }

  function getZoomScale() {
    var vv = window.visualViewport;

    if (vv && vv.scale > 0 && Math.abs(vv.scale - 1) > 0.02) {
      return vv.scale;
    }

    var innerW = getViewportWidth();
    var screenW = window.screen && (window.screen.availWidth || window.screen.width);

    if (innerW > 0 && screenW > 0 && innerW >= screenW * 0.7) {
      var fromScreen = screenW / innerW;
      if (fromScreen > 1.02) {
        return fromScreen;
      }
    }

    return 1;
  }

  function getScaleFromViewport(vw) {
    if (vw >= DESIGN_WIDTH) {
      return 1;
    }

    if (vw <= DESIGN_WIDTH / ZOOM_TARGET) {
      return ZOOM_TARGET;
    }

    return DESIGN_WIDTH / vw;
  }

  function getEffectiveScale(vw) {
    var zoomScale = getZoomScale();
    var viewportScale = getScaleFromViewport(vw);
    return Math.max(zoomScale, viewportScale);
  }

  function getOffsetForScale(scale) {
    if (scale <= 1) {
      return DESIGN_OFFSET;
    }

    if (scale >= ZOOM_TARGET) {
      return MIN_OFFSET_DESKTOP;
    }

    if (scale <= ZOOM_MID) {
      var progressTo125 = (scale - 1) / (ZOOM_MID - 1);
      return DESIGN_OFFSET - progressTo125 * (DESIGN_OFFSET - OFFSET_AT_125);
    }

    var progressTo150 = (scale - ZOOM_MID) / (ZOOM_TARGET - ZOOM_MID);
    return OFFSET_AT_125 - progressTo150 * (OFFSET_AT_125 - MIN_OFFSET_DESKTOP);
  }

  function updateLayout() {
    var vw = getViewportWidth();
    var root = document.documentElement;

    if (vw <= MOBILE_MAX) {
      var mobileContent = Math.max(0, vw - MOBILE_OFFSET * 2);

      root.style.setProperty('--yianna-layout-canvas', vw + 'px');
      root.style.setProperty('--yianna-layout-content-width', mobileContent + 'px');
      root.style.setProperty('--yianna-layout-offset-left', MOBILE_OFFSET + 'px');
      root.style.setProperty('--yianna-layout-offset-right', MOBILE_OFFSET + 'px');
      root.style.setProperty('--yianna-page-content-width', mobileContent + 'px');
      root.style.setProperty('--yianna-layout-scale', '1');
      return;
    }

    var scale = getEffectiveScale(vw);
    var offset = Math.round(getOffsetForScale(scale) * 100) / 100;
    var contentWidth = Math.max(0, vw - offset * 2);
    var contentScale = 1 + ((DESIGN_OFFSET - offset) * 2) / CONTENT_DESIGN;

    root.style.setProperty('--yianna-layout-canvas', Math.min(vw, DESIGN_WIDTH) + 'px');
    root.style.setProperty('--yianna-layout-content-width', contentWidth + 'px');
    root.style.setProperty('--yianna-layout-offset-left', offset + 'px');
    root.style.setProperty('--yianna-layout-offset-right', offset + 'px');
    root.style.setProperty('--yianna-page-content-width', contentWidth + 'px');
    root.style.setProperty('--yianna-layout-scale', String(contentScale));
  }

  updateLayout();
  document.addEventListener('DOMContentLoaded', updateLayout);
  window.addEventListener('resize', updateLayout, { passive: true });
  window.addEventListener('load', updateLayout);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateLayout, { passive: true });
  }
})();
